import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import CasinoCard from './CasinoCard';
import './CasinoGrid.css';

const CasinoGrid = ({ casinos, loading, onCasinoClick, showRatingsAndProcons, brandingLogo }) => {
  if (loading) {
    return (
      <div className="container">
        <div className="loading-container">
          <motion.div
            className="loading-spinner"
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
          >
            <img src={brandingLogo} alt="Loading..." style={{ width: '80px', height: '80px', objectFit: 'contain' }} />
          </motion.div>
          <p>Lade Casino Angebote...</p>
        </div>
      </div>
    );
  }

  if (casinos.length === 0) {
    return (
      <div className="container">
        <motion.div
          className="no-results"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <span className="no-results-icon">🔍</span>
          <h3>Keine Casinos gefunden</h3>
          <p>Versuche andere Filter-Einstellungen</p>
        </motion.div>
      </div>
    );
  }

  // Filter out hero casino from regular grid
  const regularCasinos = casinos.filter(casino => !casino.isHero);

  return (
    <div className="container">
      <motion.div
        className="casino-grid"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <AnimatePresence mode="popLayout">
          {regularCasinos.map((casino, index) => (
            <motion.div
              key={casino.id}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{
                duration: 0.4,
                delay: index * 0.05,
                ease: 'easeOut'
              }}
              layout
            >
              <CasinoCard casino={casino} onClick={() => onCasinoClick(casino)} showRatingsAndProcons={showRatingsAndProcons} />
            </motion.div>
          ))}
        </AnimatePresence>
      </motion.div>
    </div>
  );
};

export default CasinoGrid;
